import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineExtraSmallButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonEdgeButton from "../Common/CommonEdgeButton";
import { EDGE_EXTRA_SMALL_OUTLINE_BUTTONS, EDGE_EXTRA_SMALL_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";

const EdgeOutlineExtraSmallButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={OutlineExtraSmallButton} span={EDGE_EXTRA_SMALL_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn size="xs" outline color="primary" id="Tooltip-68" className="btn-pill">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-68" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-outline-primary btn-xs</ToolTip>
          {EDGE_EXTRA_SMALL_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonEdgeButton key={index} item={data} outline size="xs"/>
          ))}
        </CardBody>
      </Card>
    );
};

export default EdgeOutlineExtraSmallButtons;
